import { useQuery } from '@tanstack/react-query';

import { distributionPartnerKeys, distributionPartnersApi } from '@client/api/waterlily';

// Exposes whether the current advisor has partner auto-sharing turned on. Only an explicit consent
// record counts as auto-sharing — a null record (never set up) means manual sharing is still in
// effect.
export function useDistributionPartnerSharingConsent() {
  const query = useQuery({
    queryKey: distributionPartnerKeys.sharingConsent(),
    queryFn: () => distributionPartnersApi.getSharingConsent(),
    staleTime: 60 * 1000,
  });

  return {
    isAutoSharing: query.data?.hasConsented === true,
    isLoading: query.isLoading,
  };
}

// Whether the advisor has done the BATCH legacy share ("share all earlier clients"). Once true,
// legacy clients are already shared, so the per-client "Share with Supervisor" action is hidden.
export function useDistributionPartnerLegacyShareConsent() {
  const query = useQuery({
    queryKey: distributionPartnerKeys.hasLegacyClients(),
    queryFn: () => distributionPartnersApi.getHasLegacyClients(),
    staleTime: 60 * 1000,
  });

  return {
    hasLegacyShareConsent: query.data?.hasLegacyShareConsent === true,
    isLoading: query.isLoading,
  };
}

// Whether the "connect with distribution partners" experience should be hidden for the current
// advisor — either because their email domain belongs to a partner, or because their email is on
// the wizard-managed deny list. Drives the settings tab + onboarding step visibility.
export function useIsDistributionPartnerContact() {
  const query = useQuery({
    queryKey: distributionPartnerKeys.contactStatus(),
    queryFn: () => distributionPartnersApi.getContactStatus(),
    staleTime: 5 * 60 * 1000,
  });

  return {
    hideDistributionPartners: query.data?.hideDistributionPartners === true,
    isPartnerContact: query.data?.isPartnerContact === true,
    isBlacklisted: query.data?.isBlacklisted === true,
    isLoading: query.isLoading,
  };
}
